<template>
  <div id="app">
    <div
      class="physics"
      @mousedown="mouseDown"
      @mouseup="mouseUp"
      @mousemove="mouseMove"
      @touchstart="mouseDown"
      @touchend="mouseUp"
      @touchcancel="mouseUp"
      @touchmove="mouseMove"
    >
      <div
        v-for="particle in particles"
        :class="{particle: true, 'particle--ball': particle.ball}"
        :key="particle.id"
        :style="{transform: `translate3d(${particle.x}px, ${particle.y}px, ${particle.z}px)`, color: particle.color}"
      />
    </div>
    <div class="credit">Party with your friends at <a href="https://www.wearebraid.com">Braid</a>.</div>
  </div>
</template>

<script>
import shortid from 'shortid'

export default {
  name: 'app',
  data () {
    return {
      acceleration: 9.8 * 150,
      isDragging: false,
      cursor: {x: 0, y: 0},
      particles: []
    }
  },
  methods: {
    addObject () {
      this.particles.push({
        x: this.cursor.x,
        y: this.cursor.y,
        ball: Math.random() > .5,
        color: `hsl(${Math.random() * (360)}, 100%, 50%)`,
        initial: {
          y: this.cursor.y,
          x: this.cursor.x,
          z: 0
        },
        id: shortid.generate(),
        velocity: {
          y: Math.random() * -600 - 100,
          x: Math.random() * 300 * (Math.random() > .5 ? -1 : 1),
          z: Math.random() * 600 * (Math.random() > .5 ? -1 : 1)
        },
        time: performance.now()
      })
    },
    gravity() {
      let windowHeight = window.innerHeight
      if (this.isDragging) {
        for (let i=0; i < 3; i++) {
          this.addObject()
        }
      }
      this.particles = this.particles.map(particle => {
        let elapsed = (performance.now() - particle.time) / 1000
        particle.y = .5 * this.acceleration * Math.pow(elapsed, 2) + (particle.velocity.y * elapsed) + particle.initial.y
        particle.x = particle.initial.x + (elapsed * particle.velocity.x)
        particle.z = particle.initial.z + (elapsed * particle.velocity.z)
        return particle
      }).filter(particle => particle.y < windowHeight)
      window.requestAnimationFrame(() => this.gravity())
    },
    mouseDown(e) {
      this.mouseMove(e)
      this.isDragging = true
    },
    mouseUp () {
      this.isDragging = false
    },
    mouseMove(e) {
      if (e.targetTouches) {
        this.cursor = {x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY}
      } else {
        this.cursor = {x: e.clientX, y: e.clientY}
      }
    }
  },
  mounted () {
    this.gravity()
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

a {
  color: fuchsia;
  text-decoration: none;
}

.credit {
  position: absolute;
  top: .5em;
  left: .5em;
  font-size: 13px;
}
.physics {
  cursor: url("/cursor.png"), auto;
  width: 100vw;
  height: 100vh;
  background-size: 15px;
  overflow: hidden;
  position: relative;
  perspective: 1000px;
  transform-style: preserve-3d;
  background: linear-gradient(to bottom, #cecece, #ffffff)
}

.physics::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background-size: 15px;
  background-repeat: repeat;
  transform: rotateX(90deg);
  transform-style: preserve-3d;
  pointer-events: none;
  background-color: rgba(0, 0, 0, .1);
  position: absolute;
  bottom: 0;
  left: 0;
  transform-origin: bottom center;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) rotateX(0deg);
  }
  100% {
    transform: rotate(360deg) rotateX(360deg);
  }
}

.particle {
  position: absolute;
  margin-left: -3px;
  margin-top: -3px;
  width: 12px;
  height: 12px;
  transform-style: preserve-3d;
}

.particle::before {
  animation: rotate .2s infinite linear;
  content: '';
  display: block;
  background-color: currentColor;
  top: 0;
  left: 0;
  width: 12px;
  height: 6px;
  position: absolute;
  transform-style: preserve-3d;
}

.particle--ball::before {
  border-radius: 6px;
  width: 6px;
  height: 6px;
}
</style>
